// @ts-nocheck
export const selectCustomers = state => state.customer.customers;
export const selectCustomerDetails = state => state.customer.customerDetails;
export const selectRegions = state => state.customer.regions;
export const selectPartners = state => state.customer.partners;
